import React from "react";
import { useIntl } from "react-intl";
import {
  IonCard,
  IonCardTitle,
  IonCardContent,
  IonCardHeader,
  IonList,
  IonLabel,
  IonItem,
  IonInput,
} from "@ionic/react";
import InputItem from "../../../components/formItems/InputItem";

const Address = (props) => {
  const { activePatient } = props;
  const intl = useIntl();
  const { address, address_instructions } = activePatient;
  let arr = [];
  if (address && address.city) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.city",
      }),
      value: address.city,
    });
  }
  if (address && address.street) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.street",
      }),
      value: address.street,
    });
  }
  if (address && address.house_number) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.house_number",
      }),
      value: address.house_number,
    });
  }

  if (address && address.apartment_number) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.apartment_number",
      }),
      value: address.apartment_number,
    });
  }
  if (address_instructions && address_instructions.floor) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.floor",
      }),
      value: address_instructions.floor,
    });
  }
  if (address_instructions && address_instructions.entrance) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.entrance",
      }),
      value: address_instructions.entrance,
    });
  }

  if (address_instructions && address_instructions.required_code) {
    arr.push({
      label: intl.formatMessage({
        id: "app.mobile.patient.required_code",
      }),
      value: address_instructions.required_code,
    });
  }

  return (
    <IonCard>
      <IonCardHeader>
        <IonCardTitle>
          {intl.formatMessage({
            id: "app.mobile.forms.house_visits.patient_address",
          })}
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <IonList>
          {arr.map((item, index) => (
            <IonItem key={index}>
              <div style={{ padding: "6px 0" }}>
                <IonLabel>{item.label}</IonLabel>
                <IonLabel color="medium">{item.value}</IonLabel>
              </div>
            </IonItem>
          ))}
        </IonList>
      </IonCardContent>
    </IonCard>
  );
};

export default Address;
